// extracted by mini-css-extract-plugin
export default {"avatar":"avatar_avatar__MOv+e","photo":"avatar_photo__SUaH+","initials":"avatar_initials__FGw4y"};